import { database } from '@/firebase';

const {
  getDBTime,
  getCollection,
  getRecord,
  updateRecord,
  setRecord,
  deleteRecord,
} = database;

const publishedStripsQuery = {
  where: [{
    prop: 'publishDate',
    comparison: '<',
    value: getDBTime(),
    limit: 1,
  }],
  orderBy: [{
    prop: 'publishDate',
    direction: 'desc',
  }, {
    prop: 'number',
    direction: 'desc',
  }],
};

export default {
  fetchStrip({ commit }, { stripNumber, publishDate }) {
    let stripQuery;
    if (stripNumber) {
      const id = parseInt(stripNumber, 10).toString();
      stripQuery = getRecord({ model: 'strips', id });
    } else if (publishDate) {
      stripQuery = getCollection({
        model: 'strips',
        where: [{
          prop: 'publishDate',
          comparison: '==',
          value: publishDate,
        }],
      }).then(strips => strips[0]);
    }
    return stripQuery.then((strip) => {
      if (strip) {
        commit('saveStrip', strip);
      }
      return strip;
    });
  },
  fetchLatestStrip({ commit }) {
    return getCollection({
      model: 'strips',
      limit: 1,
      ...publishedStripsQuery,
    }).then((strips) => {
      const strip = strips && strips[0];
      if (strip) {
        commit('set', { model: 'latestStrip', value: strip.number });
        commit('saveStrip', strip);
      }
    });
  },
  fetchAllStrips({ commit }, options) {
    const { orderBy, published } = options || {};
    let query = { model: 'strips' };
    if (orderBy) {
      query = { ...query, orderBy };
    }
    if (published) {
      query = { ...query, ...publishedStripsQuery };
    }
    return getCollection(query).then((strips) => {
      strips.forEach(strip => commit('saveStrip', strip));
      return true;
    });
  },
  createStrip({ commit }, strip) {
    const stripNumber = strip.number.toString();
    return setRecord({
      model: 'strips',
      id: stripNumber,
      value: strip,
    }).then(() => commit('saveStrip', strip));
  },
  updateStrip({ commit }, strip) {
    const stripNumber = strip.number.toString();
    return updateRecord({
      model: 'strips',
      id: stripNumber,
      value: strip,
    }).then(() => commit('saveStrip', strip));
  },
  removeStrip({ commit }, stripNumber) {
    return deleteRecord({
      model: 'strips',
      id: stripNumber.toString(),
    }).then(() => commit('removeStrip', stripNumber));
  },
};
